import _, { capitalize } from 'lodash';
import { FILTER_COMPONENT_TYPES } from 'helpers/sf_constants';
import { mapActiveFilters } from 'helpers/conversation_filter_helper';
import { ADMIN_INTEGRATION_LOGS_FILTER_OBJECTS, ADMIN_INTEGRATION_LOGS_FILTER_SPECIAL_CASES, ADMIN_INTEGRATION_LOGS_FILTERS } from './admin_lead_integration_logs_helper';
import { forColumnHeaderWrapper, Sfdelimitter, SfPercentStringFormatter, sortStringAsFloat } from 'helpers/sf_utils';
import { defaultFormatter } from '../Users/UserComponents/UserList/Formatters';


export const onCloseFilterModal = (setIsActiveFilterModal, setShowFilterModal) => {
    setIsActiveFilterModal(false);
    setShowFilterModal(prev => !prev);
}

export const mappedFilterItems = (integrationOptions) => {
    const cloned_prev_items = _.cloneDeep(ADMIN_INTEGRATION_LOGS_FILTER_OBJECTS);

    return {
        ...cloned_prev_items,
        [ADMIN_INTEGRATION_LOGS_FILTERS.INTEGRATION_NAME]: {
            ...cloned_prev_items[ADMIN_INTEGRATION_LOGS_FILTERS.INTEGRATION_NAME],
            options: integrationOptions || []
        }
    };
};

export const onClickRemoveFilter = (field_name, setProspectFilterItems, fetchAdminIntegrationLogsPage, searchInputFilter = undefined) => {
    setProspectFilterItems((prev_prospect_filter_items) => {
        const cloned_prev_items = _.cloneDeep(prev_prospect_filter_items)
        const mapped_filter_items = cloned_prev_items.map((item) => {
            if (item.name !== field_name) {
                return item;
            }
            return ({ ...item, is_active: false, value: null })
        });
        const filterd_filter_items = (mapped_filter_items || []).filter(item => item.is_active);
        const allFilters = searchInputFilter ? [...filterd_filter_items, searchInputFilter] : filterd_filter_items

        fetchAdminIntegrationLogsPage(1, mapActiveFilters(allFilters, ADMIN_INTEGRATION_LOGS_FILTER_SPECIAL_CASES))
        return mapped_filter_items;
    });
}

export const onClickOpenFilterModal = (setIsActiveFilterModal, setShowFilterModal, setProspectFilterItems, mapped_filter_items) => {
    setIsActiveFilterModal(true);
    setShowFilterModal(prev => !prev);
    const mapped_filter_items_arr_objects = Object.values(mapped_filter_items);
    setProspectFilterItems((prev_prospect_filter_items) => {
        const cloned_prev_items = _.cloneDeep(prev_prospect_filter_items)
        const new_mapped_filter_items = mapped_filter_items_arr_objects.map((item) => {
            const active_filters = cloned_prev_items?.find(prev_item => prev_item.name === item.name);
            if (active_filters && active_filters.is_active) {
                return active_filters;
            }
            return item;
        });
        return new_mapped_filter_items;
    });
}

export const getActiveProspectFilters = (prospectFilterItems) => {
    if (!prospectFilterItems?.length) return { filterCount: 0, activeProspectFilterItems: [] };

    const activeProspects = prospectFilterItems.filter(item => {
        const valueField = item?.component_type === FILTER_COMPONENT_TYPES.COMPARATOR ? item?.comparator_value : item?.value;
        return item.is_active && (valueField?.length || valueField);
    });

    return { filterCount: activeProspects.length, activeProspectFilterItems: activeProspects };
};

export const adminIntegrationLogsColumns = (onClickUserLogin, onClickUserRedirection) => {
    return (
        [
            {
                dataField: "account_id",
                text: "Account ID",
                headerFormatter: forColumnHeaderWrapper,
                sort: true,
                formatter: defaultFormatter,
            },
            {
                dataField: "account_name",
                text: "Account Name",
                headerFormatter: forColumnHeaderWrapper,
                sort: true,
                formatter: (cellContent, row) => {
                    return (
                        <div className="d-flex align-items-center">
                            <a onClick={() => onClickUserLogin(row)} className="text-sfblue">
                                {cellContent}
                            </a>
                        </div>
                    )
                }
            },
            {
                dataField: "name",
                text: "Integration Name",
                headerFormatter: forColumnHeaderWrapper,
                sort: true,
                formatter: (cellContent, row) => {
                    return (
                        <div className="d-flex align-items-center">
                            <a onClick={() => onClickUserRedirection(row)} className="text-sfblue">
                                {cellContent}
                            </a>
                        </div>
                    )
                }
            },
            {
                dataField: "integration_type",
                text: "Integration Type",
                headerFormatter: forColumnHeaderWrapper,
                sort: true,
                formatter: (cell, _row) => capitalize(cell),
            },
            {
                dataField: "total_requests",
                text: "Total Requests",
                headerFormatter: forColumnHeaderWrapper,
                sort: true,
                formatter: (cellContent) => Sfdelimitter(cellContent)
            },
            {
                dataField: 'successful_requests',
                text: "Successful Requests",
                headerFormatter: forColumnHeaderWrapper,
                sort: true,
                formatter: (cellContent) => Sfdelimitter(cellContent)
            },
            {
                dataField: "success_rate",
                text: "Success Rate",
                headerFormatter: forColumnHeaderWrapper,
                sort: true,
                sortFunc: sortStringAsFloat,
                formatter: (cellContent) => SfPercentStringFormatter(cellContent)
            },
            {
                dataField: '',
                text: "Details",
                headerFormatter: forColumnHeaderWrapper,
                formatter: (_cellContent, row) => {
                    return (
                        <div className="d-flex align-items-center">
                            <a onClick={() => onClickUserRedirection(row)} className="text-sfblue">
                                Details
                            </a>
                        </div>
                    )
                }
            }
        ]
    )
}